import Vue from 'vue'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)
const common = Vue.mixin({
  data: () => {
    return {
    }
  },
  methods: {
    checkServer () {
      return this.$FUNCTIONS_URL.indexOf('global-vision') !== -1
    },
    swap (a, x, y) {
      a[x] = [a[y], a[y] = a[x]][0]
      return a
    },
    goto (context, to) {
      if (to !== context.$route.path) {
        context.$nextTick(function () {
          context.$router.push(to)
        })
      }
    },
    wait (value) {
      return new Promise(async (resolve) => {
        const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
        await pause(value).then(() => {
          resolve()
        })
      })
    },
    MMDD (date) {
      moment.tz.setDefault('Asia/Tokyo')
      return moment(date, 'YYYY-MM-DD').format('MM/DD')
    },
    getFY () {
      moment.tz.setDefault('Asia/Tokyo')
      var y = moment().year()
      var m = moment().month()
      if (m < 3) {
        y -= 1
      }
      return y
    },
    getDay (yyyy, mm, dd) {
      // var diff = 0
      // var date = new Date(String(parseInt(yyyy) + '/' + '4' + '/' + '1'))
      // var firstDay = date.getDay()
      // if (firstDay > 1) {
      //   diff = 8 - firstDay
      // } else {
      //   diff = 1 - firstDay
      // }
      // moment.tz.setDefault('Asia/Tokyo')
      // var d = new Date(String(parseInt(yyyy) + '/' + '4' + '/' + String(parseInt('1') + diff)))
      // d.setDate(d.getDate() + (((mm - 1) * 28) + (dd - 1)))
      // return d
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      var date = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + ((mm - 1) * 28) + (dd - 1), 'd').format('YYYY-MM-DD')
      return new Date(date)
    },
    getMonth (index, type) { // index: 0 - 12
      var m = index + 3
      if (m > 12) {
        m -= 12
      }
      if (index === 13) {
        m = '平均'
        if (type === 'total') {
          m = '合計'
        }
      }
      return m
    },
    getTopOfDays (yyyy, mm, ww) { // mm: 1 to 13, ww: 1 to 4
      // var diff = 0
      // var date = new Date(String(parseInt(yyyy) + '/' + '4' + '/' + '1'))
      // var firstDay = date.getDay()
      // if (firstDay > 1) {
      //   diff = 8 - firstDay
      // } else {
      //   diff = 1 - firstDay
      // }
      // moment.tz.setDefault('Asia/Tokyo')
      // var d = new Date(String(parseInt(this.year) + '/' + '4' + '/' + String(parseInt('1') + diff)))
      // d.setDate(d.getDate() + (((mm - 1) * 28) + (ww - 1) * 7))
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      var date = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + (((mm - 1) * 28) + (ww - 1) * 7), 'd').format('YYYY-MM-DD')
      var d = new Date(date)
      var value = {
        obj: d,
        str: moment(d).format('YYYY-MM-DD'),
        yyyy: moment(d).year(),
        mm: moment(d).month() + 1,
        dd: moment(d).date()
      }
      return value
    },
    checkPrimary () {
      var data = this.$store.getters['auth/data']
      if (data && typeof data.schools !== 'undefined') {
        var keys = Object.keys(data.schools)
        for (var i in keys) {
          if (data.schools[keys[i]]) {
            if (keys[i] === data.primary) {
              return true
            }
          }
        }
      }
      return false
    },
    checkPrivileges (key) {
      var privilege = true
      var data = this.$store.getters['auth/data']
      var school = this.getPrimary()
      if (school && typeof school.privileges !== 'undefined') {
        if (data && data.role === 'teacher') {
          if (typeof school.privileges[key] !== 'undefined') {
            privilege = school.privileges[key]
          }
        }
      }
      return privilege
    },
    getPrimary () {
      var data = this.$store.getters['auth/data']
      var schools = this.$store.getters['schools/schools']
      if (data !== null) {
        var keys = Object.keys(data.schools)
        for (var x in keys) {
          if (data.schools[keys[x]]) {
            var index = schools.findIndex(school => school.key === keys[x])
            if (index !== -1) {
              return JSON.parse(JSON.stringify(schools[index]))
            }
          }
        }
      }
      return null
    },
    getPrivilege (user) {
      if (!user) {
        return 'user'
      }
      if (user.role === 'admin') {
        return this.$store.getters['shared/privilege']
      }
      return user.role
    },
    getPrivilegesLevel (user) {
      if (!user) {
        return null
      }
      if (user.role === 'admin' && user.root) {
        return this.$PRIVILEGES_TABLE[user.role]
      }
      if (user.role === 'admin') {
        return this.$PRIVILEGES_TABLE[this.$store.getters['shared/privilege']]
      }
      return this.$PRIVILEGES_TABLE[user.role]
    },
    getRoleName (user) {
      var index = this.$PRIVILEGES.findIndex(privilege => privilege.role === user.role)
      if (index !== -1) {
        return this.$PRIVILEGES[index].name
      }
      return '講師'
    },
    getRoleIcon (user) {
      var index = this.$PRIVILEGES.findIndex(privilege => privilege.role === user.role)
      if (index !== -1) {
        return this.$PRIVILEGES[index].icon
      }
      return 'mdi-account'
    },
    getDescriptionColor (item, mode) {
      if (item.type === 'holiday') {
        if (mode) {
          return mode === 1 ? '#FFCDD2' : '#B71C1C'
        }
        return '#F44336'
      }
      var index = this.$DESCRIPTIONS_ITEMS.findIndex(description => description.key === item.category)
      if (index !== -1) {
        if (mode) {
          return mode === 1 ? this.$DESCRIPTIONS_ITEMS[index].light : this.$DESCRIPTIONS_ITEMS[index].dark
        }
        return this.$DESCRIPTIONS_ITEMS[index].rgb
      }
      if (mode) {
        return mode === 1 ? '#F5F5F5' : '#212121'
      }
      return '#9E9E9E'
    },
    getCategoryColor (item) {
      if (item.category === 0) {
        return 'red'
      }
      var index = this.$DESCRIPTIONS_ITEMS.findIndex(description => description.key === item.category)
      if (index !== -1) {
        return this.$DESCRIPTIONS_ITEMS[index].color
      }
      return 'primary'
    },
    getHeaderColor () {
      return '#10101010'
    },
    getWeekColor (i) {
      var value = i % 7
      if (value === 6) {
        return '#E3F2FD80'
      } else if (value === 0) {
        return '#F8BBD060'
      } else {
        return '#10101010'
      }
    },
    getWeekColorClass (i) {
      var value = i % 7
      if (value === 6) {
        return 'px-0 blue--text'
      } else if (value === 0) {
        return 'px-0 error--text'
      } else {
        return 'px-0'
      }
    },
    checkDay (yyyy, mm, dd) {
      var yy = yyyy
      if (mm > 9) {
        yy += 1
      }
      var date = yy + '-' + this.$MONTH[mm - 1] + '-01'
      moment.tz.setDefault('Asia/Tokyo')
      return dd <= moment(date).daysInMonth()
    },
    getGroupName (groups, item) {
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        if (item.groups[keys[i]]) {
          var index = groups.findIndex(group => group.key === keys[i])
          if (index !== -1) {
            return groups[index].name
          }
        }
      }
      return ''
    },
    genUUIDv4 () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0; var v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    getRandom () {
      var l = 10
      var c = 'abcdefghijkLmnopqrstuvwxyzABCDEFGHIJKMNPQRSTUVWXYZ0123456789'
      var cl = c.length
      var r = ''
      for (var i = 0; i < l; i++) {
        r += c[ Math.floor(Math.random() * cl) ]
      }
      return r
    },
    getRandomRamge (min, max) {
      var random = Math.floor(Math.random() * (max + 1 - min)) + min
      return random
    },
    getGrade (user, date) {
      var preschool = this.$store.getters['shared/preschool']
      var extension = this.$store.getters['shared/extension']
      var grade = null
      if (!user) {
        return grade
      }
      if (!moment(user.birth).isValid()) {
        if (user.grade !== null) {
          grade = user.grade
        }
        return grade
      }
      if (user.birth) {
        if (date) {
          var yyyy = moment(date).year()
          var m = moment(moment(date).year() + '-04' + '-01')
          if (moment(date).isBefore(m)) {
            yyyy -= 1
          }
          if (extension === 1) {
            grade = yyyy - moment(user.birth).year()
          } else {
            grade = yyyy - moment(user.birth).year() - 6
          }
        } else {
          yyyy = moment().year()
          m = moment(moment().year() + '-04' + '-01')
          if (moment().isBefore(m)) {
            yyyy -= 1
          }
          if (extension === 1) {
            grade = yyyy - moment(user.birth).year()
          } else {
            grade = yyyy - moment(user.birth).year() - 6
          }
        }
        m = moment(moment(user.birth).year() + '-04' + '-02')
        if (moment(user.birth).isBefore(m)) {
          grade += 1
        }
        if (preschool && extension === 1) {
          if (grade < 0) {
            grade = 0
          }
          if (grade < 7) {
            grade += 23
          } else {
            grade -= 6
            if (grade > 13) {
              grade = 13
            }
          }
        } else if (preschool) {
          if (grade < 0) {
            grade = 0
          }
          if (grade > 13) {
            grade = 13
          }
        } else {
          if (grade < 1) {
            grade = 1
          }
          if (grade > 13) {
            grade = 13
          }
        }
      } else if (user.grade !== null) {
        grade = user.grade
      }
      return grade
    },
    logs (payload) {
      this.$store.dispatch('logs/write', {
        date: new Date().toISOString(),
        body: payload
      })
    },
    changeGrade (context) {
      var schools = context.$store.getters['schools/schools']
      var index = schools.findIndex(s => s.key === localStorage.school)
      if (index !== -1) {
        context.$store.dispatch('shared/setExtension', '')
        if (schools[index].preschool) {
          if (typeof schools[index].extension !== 'undefined' && schools[index].extension === 1) {
            Vue.prototype.$GRADES = [
              // { key: 23, name: '0歳' },
              // { key: 24, name: '1歳' },
              // { key: 25, name: '2歳' },
              { key: 26, name: '3歳' },
              { key: 27, name: '4歳' },
              { key: 28, name: '5歳' },
              { key: 29, name: '6歳' },
              { key: 1, name: '小学1年生' },
              { key: 2, name: '小学2年生' },
              { key: 3, name: '小学3年生' },
              { key: 4, name: '小学4年生' },
              { key: 5, name: '小学5年生' },
              { key: 6, name: '小学6年生' },
              { key: 7, name: '中学1年生' },
              { key: 8, name: '中学2年生' },
              { key: 9, name: '中学3年生' },
              { key: 10, name: '高校1年生' },
              { key: 11, name: '高校2年生' },
              { key: 12, name: '高校3年生' },
              { key: 13, name: '社会人' }
            ]
            context.$store.dispatch('shared/setExtension', schools[index].extension)

            Vue.prototype.$STATUS = [
              { key: 1, name: '問合せ' },
              { key: 2, name: '保護者面談' },
              { key: 3, name: '体験授業' },
              { key: 4, name: '提案' },
              { key: 5, name: '入会' },
              { key: 6, name: '在籍' },
              { key: 7, name: '退会' },
              { key: 8, name: '逸失' }
            ]
            Vue.prototype.$ACTIONS = [
              { key: 1, name: 'DTS' }, // 9
              { key: 2, name: '生徒面談' }, // 10
              { key: 3, name: '保護者面談' }, // 11
              { key: 4, name: 'YCS' }, // 12
              { key: 5, name: '約束' }, // 13
              { key: 6, name: '退会' }, // 14
              { key: 7, name: 'その他' } // 15
            ]
            Vue.prototype.$MEDIAS = [
              { key: 1, name: 'HP' },
              { key: 2, name: 'インスタグラム' },
              { key: 3, name: 'FB' },
              { key: 4, name: '新聞折込チラシ' },
              { key: 5, name: 'ポスティングチラシ' },
              { key: 6, name: '校門前配布' },
              { key: 7, name: '学校紹介' },
              { key: 8, name: '通りがかり' },
              { key: 9, name: '弟妹' },
              { key: 10, name: 'その他' }
            ]
          } else {
            Vue.prototype.$GRADES = [
              { key: 0, name: '幼児' },
              { key: 1, name: '小学1年生' },
              { key: 2, name: '小学2年生' },
              { key: 3, name: '小学3年生' },
              { key: 4, name: '小学4年生' },
              { key: 5, name: '小学5年生' },
              { key: 6, name: '小学6年生' },
              { key: 7, name: '中学1年生' },
              { key: 8, name: '中学2年生' },
              { key: 9, name: '中学3年生' },
              { key: 10, name: '高校1年生' },
              { key: 11, name: '高校2年生' },
              { key: 12, name: '高校3年生' },
              { key: 13, name: '既卒' }
            ]
          }
          context.$store.dispatch('shared/setPreschool', true)
        } else {
          Vue.prototype.$GRADES = [
            { key: 1, name: '小学1年生' },
            { key: 2, name: '小学2年生' },
            { key: 3, name: '小学3年生' },
            { key: 4, name: '小学4年生' },
            { key: 5, name: '小学5年生' },
            { key: 6, name: '小学6年生' },
            { key: 7, name: '中学1年生' },
            { key: 8, name: '中学2年生' },
            { key: 9, name: '中学3年生' },
            { key: 10, name: '高校1年生' },
            { key: 11, name: '高校2年生' },
            { key: 12, name: '高校3年生' },
            { key: 13, name: '既卒' }
          ]
          context.$store.dispatch('shared/setPreschool', false)
        }
      }
    },
    getGradeName (grade) {
      var index = this.$GRADES.findIndex(g => g.key === grade)
      if (index !== -1) {
        return this.$GRADES[index].name
      }
      return '不明'
    }
  }
})
export default common
